import {createContext} from "@core-ui/utility";
import {
  CleanedLocale,
  TranslationsForLocale,
  Localize,
  FormatCurrency,
} from "./types";

export type LocalizationContextType = {
  locale: CleanedLocale;
  translations: TranslationsForLocale;
  localize: Localize;
  formatCurrency: FormatCurrency;
};

const [useLocalization, LocalizationContext]: [
  () => LocalizationContextType,
  React.Context<LocalizationContextType | undefined>
] = createContext<LocalizationContextType>(
  "useLocalize called without LocalizationProvider"
);

export {useLocalization, LocalizationContext};
